module.exports = __webpack_public_path__ + "img/img_pass@.385a63cc.png";